import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { GetStockParams } from "../../../models/Stock/GetStockParams";
import {
  Product,
  Stock,
  StockCheckRequestStatus,
  StockCheckSuggestedProducts,
} from "../../../models/Stock/Stock";
import { getAPI, patchAPI, postAPI, putAPI } from "../../../api/Networking";

export default class StockAPI {
  getStockList = async (
    params: GetStockParams,
  ): Promise<PaginatedAPIResponse<Stock>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page_no)
        queryParams.append("page_no", params.page_no.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.sortBy) queryParams.append("sort_by", params.sortBy);
      if (params.sortType)
        queryParams.append("sort_type", params.sortType.toString());
      if (params.status != null)
        queryParams.append("status", params.status.toString());
      if (params.order_id)
        queryParams.append("order_id", params.order_id.toString());
      if (params.order_type_ids && params.order_type_ids.length > 0)
        queryParams.append("order_type", params.order_type_ids.join(","));
      // if (params.name) queryParams.append("name", params.name);
      // if (params.category_id && params.category_id.length !== 0)
      //   queryParams.append("category_id", params.category_id.join(","));
      // queryParams.append("active", params.active === false ? "0" : "1");
      // if (params.active)
      //
      // else queryParams.append("active", "true");
      const response = await getAPI(
        `/v5/stock-check-requests?${queryParams.toString()}`,
      );
      return response.result as PaginatedAPIResponse<Stock>;
    } catch (error) {
      throw error;
    }
  };

  //   getProducts = async (
  //     params: GetProductsParams
  //   ): Promise<PaginatedAPIResponse<Product>> => {
  //     try {
  //       const queryParams = new URLSearchParams();
  //       if (params.page_no)
  //         queryParams.append("page_no", params.page_no.toString());
  //       if (params.limit) queryParams.append("limit", params.limit.toString());
  //       if (params.sortBy) queryParams.append("sort_by", params.sortBy);
  //       if (params.sortType)
  //         queryParams.append("sort_type", params.sortType.toString());
  //       if (params.name) queryParams.append("name", params.name);
  //       if (params.category_id && params.category_id.length !== 0)
  //         queryParams.append("category_id", params.category_id.join(","));
  //       queryParams.append("active", params.active === false ? "0" : "1");
  //       // if (params.active)
  //       //
  //       // else queryParams.append("active", "true");
  //       const response = await getAPI(`/v5/products?${queryParams.toString()}`);
  //       return response.result as PaginatedAPIResponse<Product>;
  //     } catch (error) {
  //       throw error;
  //     }
  //   };

  getStockListByOrderId = async (orderId: number) => {
    try {
      const response = await getAPI(
        `/v5/stock-check-requests/order-id/${orderId}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getEligibleProductsByOrderId = async (orderId: number) => {
    try {
      const response = await getAPI(
        `/v5/stock-check-requests/order-id/${orderId}/eligible-products`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  raiseStockCheckRequest = async (orderId: number, products: Product[]) => {
    try {
      const prod = {
        products,
      };
      const response = await postAPI(
        `/v5/stock-check-requests/order-id/${orderId}`,
        prod,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  updateExecutionWarehouses = async (
    orderId: number,
    requestId: number,
    warehouseIdentifiers: string[],
  ) => {
    try {
      const response = await putAPI(
        `/v5/stock-check-requests/order-id/${orderId}/request-id/${requestId}/warehouses`,
        { warehouse_identifiers: warehouseIdentifiers },
      );
      return response.result as {
        request_id: number;
        warehouse_identifiers: string[];
      };
    } catch (error) {
      throw error;
    }
  };

  updateStockCheckRequest = async (
    orderId: number,
    requestId: number,
    options: {
      status?: number;
      products?: Product[];
      suggestedProducts?: StockCheckSuggestedProducts[];
      warehouseIdentifiers?: string[];
    },
  ) => {
    try {
      const body: {
        status?: number;
        products?: Product[];
        suggested_products?: StockCheckSuggestedProducts[];
        warehouse_identifiers?: string[];
      } = {};
      if (options.status !== undefined) {
        body.status = options.status;
        if (
          options.status === StockCheckRequestStatus.CLOSED &&
          options.warehouseIdentifiers &&
          options.warehouseIdentifiers.length > 0
        ) {
          body.warehouse_identifiers = options.warehouseIdentifiers;
        }
        const response = await putAPI(
          `/v5/stock-check-requests/order-id/${orderId}/request-id/${requestId}`,
          body,
        );
        return response;
      }

      if (options.products || options.suggestedProducts) {
        if (options.products) {
          body.products = options.products;
        }

        if (options.suggestedProducts) {
          body.suggested_products = options.suggestedProducts;
        }

        const response = await putAPI(
          `/v5/stock-check-requests/order-id/${orderId}/request-id/${requestId}`,
          body,
        );
        return response;
      }
    } catch (error) {
      throw error;
    }
  };

  deleteSuggestedProduct = async (
    requestId: number,
    productId: number,
    suggestedProductId: number,
  ) => {
    try {
      const response = await patchAPI(
        `/v5/stock-check-requests/request-id/${requestId}/product-id/${productId}/suggested-products/${suggestedProductId}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
